module.exports = __webpack_public_path__ + "img/bishop.29d65d75.webp";